import { Reveal } from "./Reveal";

const quotes = [
  {
    q: "I arrived exhausted and left feeling like I'd remembered something essential about myself. The sound baths undid years of tension.",
    a: "Maya R.",
    r: "Weekend Renewal",
  },
  {
    q: "The most luxurious thing wasn't the suite — it was the silence, and the permission to simply be.",
    a: "Daniel K.",
    r: "Signature Retreat",
  },
  {
    q: "Friendly, grounded and deeply restorative. I think about my morning ritual here every single day.",
    a: "Aisha M.",
    r: "Day Immersion",
  },
];

export const Testimonials = () => (
  <section className="py-24 md:py-32 bg-forest text-sand">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs tracking-[0.3em] uppercase text-dune mb-12">Voices from the retreat</p>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-10 lg:gap-16">
        {quotes.map((t, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <div data-testid={`testimonial-${i}`}>
              <p className="font-serif font-light text-2xl sm:text-[1.7rem] leading-snug">"{t.q}"</p>
              <div className="mt-6 pt-6 border-t border-sand/20">
                <p className="text-sand">{t.a}</p>
                <p className="text-sm text-dune">{t.r}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
